import { Component, OnInit, Input } from '@angular/core';
import { Horse } from '../../../models/horse';

@Component({
  standalone: false,
  selector: 'view-horse',
  inputs: ['horse'],
  templateUrl: './view-horse.component.html',
styleUrls:  ['./view-horse.component.css']
})
export class ViewHorseComponent implements OnInit {
	@Input() horse: Horse;

  constructor() { }

  ngOnInit() {
  }

}
